import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman, FcFilmReel } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";

const ViewGuestDetails = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/guest/view/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting guest!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  const linkifyText = (text) => {
    if (!text) return "N/A";

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcBusinessman className="fs-2 me-1" />
                  Guest Management
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Guest Details</h2>
            </div>

            <div className="card-body">
              {!data ? (
                <div className="text-center text-muted">No data found</div>
              ) : (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Guest Name</label>
                    <div className="w-100 col">{data?.guestName || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Guest Business Name
                    </label>
                    <div className="w-100 col">
                      {data?.guestBusinessName || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Guest Description{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.guestDescription || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Guest Podcast{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.guestPodcast) || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Guest Contact Number{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.guestContactNum || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Guest Email Id{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.guestEmailId || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Guest Instagram Profile{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.guestInstaProfile || "N/A")}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Guest Interested To JoinGuest Interested To Join{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.guestIntrested || "N/A"}
                    </div>
                  </div>

                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <SimpleButton
                        buttonText="Edit Guest Info"
                        href={`/edit-guest/${id}`}
                      />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewGuestDetails;
